import { IRect } from '@src/slide/infrastructure/module/independent/graphic/rect/rect';

export enum ImageRelativeResizeType {
    noRelative = 0,
    isRelative = 1,
    multi = 2, // 多选的情况下
}

// 新的宽高相关属性
export interface INextWH extends IRect {
    srcRect: IPictureSrcRect;
}

export interface IOriginalSize {
    width: number;
    height: number;
}

export interface IPictureSrcRect {
    b: number
    l: number
    r: number
    t: number
}

export interface ISizeInfo {
    width?: number, height?: number, srcRect?: Partial<IPictureSrcRect>
}

export interface IForegroundSize {
    rw: number; // 实际宽度
    rh: number; // 实际高度
    pl: number, // 左侧偏移值
    pr: number, // 右侧偏移值
    pt: number, // 上侧偏移值
    pb: number, // 下侧偏移值
}

export interface ISlideWH {
    slideWidth: number;
    slideHeight: number;
}

export interface IImageSize {
    /**
     * 获取相对图片原始尺寸属性。
     */
    getRelativeResize(): ImageRelativeResizeType;
    /**
     * 改变相对图片原始尺寸属性。
     */
    handleRelativeResize(value: number | boolean): void;
    /**
     * 重置大小
     */
    resetSize(): void;
    /**
     * 获取图片原始尺寸
     */
    getOriginalSize(): IOriginalSize;
    /**
     * 获取图片的前景图大小，即图片的实际大小
     */
    getForegroundImageSize(props?: ISizeInfo): IForegroundSize;
    /**
     * 更新图片的前景图大小，即图片的实际大小
     */
    updateForegroundImageSize(props: Partial<IForegroundSize>): void;
}
